<template>
    <v-img :src="computedPath" :max-width="logoMaxSize" :max-height="logoMaxSize" v-bind="$attrs" contain />
</template>

<script>
export default {
    name: 'MeetLogo',

    props: {
        path: {
            type: String,
            default: '',
        },
    },

    computed: {
        computedPath() {
            if (this.path === '/images/logo-dark.png' && this.$vuetify.theme.dark) {
                return '/images/logo-white.png';
            }

            return this.path;
        },

        logoMaxSize() {
            if (this.$vuetify.breakpoint.smAndDown) {
                return '150';
            }
            if (this.$vuetify.breakpoint.md) {
                return '200';
            }
            if (this.$vuetify.breakpoint.lgAndUp) {
                return '250';
            }

            return '150';
        },
    },
};
</script>
